<div class="mic-selector">
  <button type="button" class="mic-trigger"
    [class.has-device]="hasDevices"
    [class.no-device]="!hasDevices"
    (click)="toggleDropdown($event)"
    title="Select microphone">
    @if (hasDevices) {
    <svg viewBox="0 0 24 24" class="mic-icon" aria-hidden="true">
      <defs>
        <linearGradient [attr.id]="uid + '-fill'" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stop-color="#22c55e" />
          <stop offset="100%" stop-color="#4ade80" />
        </linearGradient>
        <clipPath [attr.id]="uid + '-clip'">
          <path
            d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2Zm-5 8a7 7 0 0 0 7-7h-2a5 5 0 0 1-10 0H5a7 7 0 0 0 7 7Zm-1 0v3h2v-3h-2Z" />
        </clipPath>
      </defs>
      <path
        d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2Zm-5 8a7 7 0 0 0 7-7h-2a5 5 0 0 1-10 0H5a7 7 0 0 0 7 7Zm-1 0v3h2v-3h-2Z"
        fill="#d1d5db" />
      <rect x="0" [attr.y]="24 - (scaledVolumeLevel / 100) * 24" width="24"
        [attr.height]="(scaledVolumeLevel / 100) * 24" [attr.fill]="'url(#' + uid + '-fill)'"
        [attr.clip-path]="'url(#' + uid + '-clip)'" />
    </svg>
    } @else {
    <mat-icon class="mic-missing">mic_off</mat-icon>
    }
    <mat-icon class="mic-chevron" aria-hidden="true">expand_more</mat-icon>
  </button>

  @if (showDropdown) {
  <div class="mic-dropdown">
    @if (hasDevices || showTelehealthSource) {
    @if (audioInputDevices.length > 0) {
    <div class="dropdown-section">
      <div class="dropdown-section-label">Microphone</div>
      @for (device of audioInputDevices; track device.deviceId) {
      <button type="button" class="dropdown-item"
        [class.selected]="selectedDeviceId === device.deviceId"
        (click)="selectDevice(device.deviceId)">
        <span>{{ device.label || 'Unnamed Mic' }}</span>
        @if (selectedDeviceId === device.deviceId) {
        <mat-icon class="check-icon">check</mat-icon>
        }
      </button>
      }
    </div>
    }

    @if (audioInputDevices.length > 0 && showTelehealthSource) {
    <div class="dropdown-divider"></div>
    }

    @if (showTelehealthSource) {
    <div class="dropdown-section">
      <div class="dropdown-section-label">Audio Source</div>
      <button type="button" class="dropdown-item selected">
        <span>{{ telehealthLabel }}</span>
        @if (hasActiveTelehealthAudio) {
        <span class="active-label">Active</span>
        }
        <mat-icon class="check-icon">check</mat-icon>
      </button>
    </div>
    }
    } @else {
    <div class="no-devices">
      No input device found. Please check your permissions or input devices and refresh the page.
    </div>
    }
  </div>
  }
</div>
